<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-06 14:43:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-08 15:32:45
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/tableCells/opeationCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="delete-text cursor-pointer fz-12" @click="onDelete(row)">
		移除
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	inject: {
		injectUpdateTableData: {
			default: () => {
				return () => {};
			},
		},
		
	},
	data() {
		return {};
	},
	components: {
	
	},
	computed: {
	},
	props: {},

	mounted() {},

	methods: {
		onDelete(row){
			this.injectUpdateTableData(row, 'delete')
		}
	},
};
</script>
<style lang="less" scoped>
.delete-text{
	color: @color-b4
}
</style>
